import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import { constructionAsset, constructionEquipment, constructionSafety } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import video from '@src/assets/images/solution/manufacturingProcess/video/rtlsVideo.mp4';

export default {
  desc: 'Smart Shipyard (Nhà máy đóng tàu thông minh) là việc xây dựng một hệ thống sản xuất hiệu quả và thông minh hơn bằng cách sử dụng các công nghệ tiên tiến như Trí tuệ nhân tạo (AI), Internet vạn vật (IoT), RTLS (theo dõi vị trí theo thời gian thực) và Digital Twin.',
  keywords: 'Smart Shipyard,Nhà máy đóng tàu, Nha may dong tau,Nganh Cong Nghiep Cang,DigitalTwin,RTLS',
  ogSite: 'Giải pháp Smart Shipyard',
  title: 'Giải pháp Smart Shipyard',
  ogUrl: 'https://orbro.io/vi/blog/smart-shipyard',
  ogImg: 'https://lh3.google.com/u/0/d/1WdXSNBhEft64iXMMY189UfAb4GJnSnFp=w2000-h7622-iv1',
  ogType: 'website',
  date: '2024-05-09',
  tag1: 'SmartShipyard',
  tag2: 'Nhamaydongtau',
  tag3: 'Nganhcongnghiepcang',
  tag4: 'DigitalTwin',
  text: [
    {
      head: 'Giải pháp Smart Shipyard',
      subHead: '',
      desc: 'Smart Shipyard (Nhà máy đóng tàu thông minh) là việc xây dựng một hệ thống sản xuất hiệu quả và thông minh hơn bằng cách sử dụng các công nghệ tiên tiến như Trí tuệ nhân tạo (AI), Internet vạn vật (IoT), RTLS (theo dõi vị trí theo thời gian thực) và Digital Twin. Smart Shipyard hướng tới việc xây dựng một ngành công nghiệp hàng hải bền vững bằng cách tăng cường an toàn cho người lao động, nâng cao năng suất và cải thiện hiệu quả năng lượng thông qua số hóa và tự động hóa quy trình sản xuất.\nTrong blog này, chúng ta sẽ tìm hiểu về khái niệm và lợi ích của giải pháp Smart Shipyard, cùng với công nghệ Digital Twin và RTLS – những công nghệ cốt lõi của nó.',
      dot: '',
    },
    {
      head: 'Những công nghệ chính',
      subHead: 'Theo dõi vị trí theo thời gian thực (RTLS) ',
      desc: 'RTLS giúp nâng cao tính minh bạch và tối đa hóa hiệu quả của quy trình sản xuất bằng cách theo dõi vị trí theo thời gian thực của người lao động và tài sản. Công nghệ này cung cấp thông tin vị trí chính xác được cập nhật từng giây, giúp tối ưu hóa lịch trình làm việc và tăng cường an toàn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Digital Twin',
      desc: 'Digital Twin là công nghệ tạo ra một mô hình ảo bằng cách kết nối tất cả các yếu tố của nhà máy đóng tàu giữa thế giới thực và kỹ thuật số. Thông qua đó, có thể mô phỏng và tối ưu hóa quy trình thực tế, đồng thời nâng cao năng suất và hiệu quả ở mọi giai đoạn, từ thiết kế đến sản xuất và bảo trì.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Sử dụng Big Data và trí tuệ nhân tạo (AI)',
      desc: 'Thu thập và phân tích lượng lớn dữ liệu được tạo ra tại nhà máy đóng tàu để tối ưu hóa quy trình sản xuất và thực hiện bảo trì dự đoán. Thông qua Trí tuệ nhân tạo, khám phá các quy luật trong dữ liệu và dựa trên đó hỗ trợ dự đoán và ra quyết định, từ đó nâng cao năng suất và cắt giảm chi phí.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Áp dụng công nghệ Internet vạn vật (IoT)',
      desc: 'Kết nối các thiết bị và cảm biến đa dạng bên trong tàu và nhà máy đóng tàu để thu thập và giám sát dữ liệu theo thời gian thực, tối ưu hóa quy trình sản xuất. Thông qua đó, có thể nắm bắt trạng thái thiết bị theo thời gian thực và thực hiện bảo trì phòng ngừa, nâng cao năng suất.',
      dot: '',
    },
    {
      head: 'Những chức năng chính',
      subHead: 'Theo dõi vị trí người lao động theo thời gian thực',
      desc: 'Theo dõi vị trí người lao động theo thời gian thực giúp tối ưu hóa lịch trình làm việc và duy trì an toàn cho môi trường làm việc. Điều này cho phép giám sát vị trí người lao động theo thời gian thực để ngăn ngừa các tình huống nguy hiểm từ sớm và tối đa hóa hiệu quả công việc.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý tài sản theo thời gian thực',
      desc: 'Giám sát vị trí và trạng thái của tài sản trong nhà máy đóng tàu theo thời gian thực giúp cải thiện quản lý tồn kho và hiệu quả công việc. Thông qua đó, ngăn ngừa các vấn đề như thiếu hàng tồn kho hoặc mua quá mức và tối ưu hóa tỷ lệ sử dụng tài sản.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý môi trường ',
      desc: 'Giám sát các yếu tố môi trường để ngăn ngừa ô nhiễm môi trường trong nhà máy đóng tàu và duy trì tính bền vững của quy trình sản xuất. Điều này cho phép giám sát các yếu tố môi trường như không khí, chất lượng nước, tiếng ồn theo thời gian thực để thực hiện các biện pháp và cải thiện môi trường sản xuất.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý khu vực nguy hiểm',
      desc: 'Xác định và giám sát các khu vực nguy hiểm trong nhà máy đóng tàu để đảm bảo an toàn cho người lao động và giảm thiểu tai nạn có thể xảy ra trong quá trình làm việc. Điều này giúp xác định các khu vực nguy hiểm và cung cấp cảnh báo cho người lao động để duy trì môi trường làm việc an toàn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý hiệu quả năng lượng',
      desc: 'Áp dụng hệ thống năng lượng thông minh để tối ưu hóa mức tiêu thụ năng lượng của nhà máy đóng tàu và thực hiện vận hành thân thiện với môi trường.',
      dot: '',
    },
    {
      head: 'Triển vọng phát triển tương lai',
      subHead: 'Mở rộng Trí tuệ nhân tạo (AI) và công nghệ tự hành',
      desc: 'Trong tương lai, công nghệ AI được dự kiến sẽ phát triển hơn nữa và công nghệ tàu tự hành sẽ được phổ biến. Thông qua đó, nhà máy đóng tàu sẽ có thể nâng cao hiệu quả vận hành và giảm chi phí nhân lực trong quá trình sản xuất.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Ứng dụng công nghệ Internet vạn vật (IoT)',
      desc: 'Công nghệ IoT được dự kiến sẽ đóng vai trò ngày càng quan trọng hơn trong vận hành và quản lý nhà máy đóng tàu. Bằng cách thu thập và phân tích dữ liệu từ các cảm biến gắn trên tàu và các thiết bị khác, có thể nâng cao hiệu quả vận hành của nhà máy đóng tàu.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Nhấn mạnh công nghệ thân thiện với môi trường',
      desc: 'Để hướng tới một ngành công nghiệp hàng hải bền vững, các công nghệ cải thiện hiệu quả năng lượng và bảo vệ môi trường được dự kiến sẽ được nhấn mạnh. Những nỗ lực này sẽ nâng cao tính bền vững của hoạt động nhà máy đóng tàu cùng với việc bảo tồn hệ sinh thái biển.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tăng trưởng thị trường toàn cầu',
      desc: 'Ngành công nghiệp cảng và đóng tàu toàn cầu được dự đoán sẽ tiếp tục tăng trưởng. Đặc biệt, cùng với sự gia tăng các dự án xây dựng và mở rộng cảng mới, sự tăng trưởng ở khu vực Châu Á - Thái Bình Dương được dự kiến, điều này sẽ có tác động tích cực đến ngành công nghiệp Smart Shipyard của Hàn Quốc.',
      dot: '',
    },
    {
      head: 'Kết luận',
      subHead: '',
      desc: 'Smart Shipyard đang trở thành một yếu tố thiết yếu cho ngành công nghiệp hàng hải bền vững trong tương lai. Bằng việc áp dụng các công nghệ tiên tiến và tiếp cận đổi mới, nó có thể nâng cao năng suất, hiệu quả, an toàn và đồng thời hiện thực hóa phương thức sản xuất thân thiện với môi trường. Thông qua đó, ngành đóng tàu được kỳ vọng sẽ phát triển nhanh chóng hơn và đạt được sự tăng trưởng bền vững trong tương lai.',
      dot: '',
    },
  ],
  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionEquipment.thumb,
        data: 'constructionEquipment',
        link: '/vi/enterprise/construction/equipment',
      },
    ],
  },
};
